<template>
  <label class="app-cb" :class="{ 'app-cb--disabled': disabled }">
    <span class="app-cb__box">
      <input
        :id="id"
        type="checkbox"
        class="app-cb__input"
        :checked="!!value"
        :disabled="disabled"
        v-bind="$attrs"
        @change="onChange"
      />
      <app-icon v-if="value" name="check" :size="10" class="app-cb__check" />
    </span>
    <span v-if="hasLabel()" class="app-cb__label"><slot>{{ label }}</slot></span>
  </label>
</template>

<script>
// Checkbox (Spezifikation 2.6): natives <input type="checkbox"> (appearance: none) im <label>; Ziel ist die ganze
// Zeile (32/44). value (Boolean) mit v-model; Ereignisse input und change (Boolean). Text über label oder Slot.
import AppIcon from './AppIcon.vue';

export default {
  name: 'AppCheckbox',
  components: { AppIcon },
  inheritAttrs: false,
  props: {
    value: { type: Boolean, default: false },
    label: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    id: { type: String, default: null }
  },
  methods: {
    hasLabel() {
      return !!this.label || !!this.$slots.default || !!this.$scopedSlots.default;
    },
    onChange(e) {
      const checked = !!e.target.checked;
      // Zustand bleibt gesteuert: das DOM folgt value, sobald die Seite den neuen Wert übernimmt
      e.target.checked = !!this.value;
      this.$emit('input', checked);
      this.$emit('change', checked);
    }
  }
};
</script>
